import { useListBrandSettings } from '@frontend/api-brand-settings';
import { useAppScopeNaming, useAppScopeSelection } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';
import { calculatePracticeName } from './calculate-practice-name';

/**
 * Hook to synchronously retrieve the practice name for a given location.
 * @param selectedLocationId - The ID of the location to retrieve the practice name for.
 * @param fallbackName - Optional fallback name to use if no practice name is found.
 * @returns The resolved practice name string for the given location.
 */
export const usePracticeName = (selectedLocationId: string, fallbackName?: string) => {
  const { getScopeName } = useAppScopeNaming();
  const { selectedOrgId } = useAppScopeSelection();

  const { getFeatureFlagValue } = useAppFlagStore();
  const isBrandSettingsEnabled = getFeatureFlagValue({ locationIds: [selectedLocationId], flagName: 'brand-settings' });

  const { data: brandSettings = {} } = useListBrandSettings({
    locationIds: [selectedLocationId],
    orgId: selectedOrgId,
    queryOptions: {
      enabled: isBrandSettingsEnabled,
    },
  });

  return calculatePracticeName({
    brandSettings,
    fallbackName,
    isBrandSettingsEnabled,
    locationName: getScopeName(selectedLocationId),
    selectedLocationId,
  });
};
